import { render, staticRenderFns } from "./SidebarLayout.vue?vue&type=template&id=033949ce&scoped=true"
import script from "./SidebarLayout.vue?vue&type=script&lang=js"
export * from "./SidebarLayout.vue?vue&type=script&lang=js"
import style0 from "./SidebarLayout.vue?vue&type=style&index=0&id=033949ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033949ce",
  null
  
)

export default component.exports